var _defs, _path, _path2, _path3, _path4, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsp4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164.93 126.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -370.74,
    y1: 84.53,
    x2: -334.52,
    y2: 15.97,
    gradientTransform: "matrix(1, 0, 0.38, -0.98, 374.98, 107.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -363.52,
    y1: 88.34,
    x2: -327.3,
    y2: 19.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 101.81,
    y1: 2.7,
    x2: 145.19,
    y2: -6.88,
    gradientTransform: "matrix(1, 0, 0, -1, -65.98, 85.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 112.01,
    y1: 136.55,
    x2: 116.22,
    y2: 105.06,
    gradientTransform: "matrix(1, 0, 0, -1, -4.91, 138.67)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M33.47,127.64a63.65,63.65,0,0,0,6.72,1.42c12.68,2,25.67.84,38.41,2.38,13.49,1.62,26.59,6.27,40.19,2.92,10.9-2.69,20.59-9.56,27.68-18.15,9.94-12,15.37-27.14,19.51-42.18,4.64-16.83,7.15-37.05-4.77-49.8-9.52-10.2-25-11.81-38.94-11.27-7.37.29-14.74,1-22.11.76s-13.07-2.66-19.86-4C69.48,7.57,55.66,14.81,48.16,22c-9,8.58-14,20.53-22.33,29.73C20.23,57.9,13.09,62.92,9.3,70.34A40.77,40.77,0,0,0,5.74,82.86c-1.36,9.07-1.44,18.77,2.78,26.91C13.38,119.15,23.1,124.82,33.47,127.64Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#3cbdea",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.85,26.47s31.38,13.94,32.46,33.35S97.81,75.73,85,84.1s-68.33,21.09-67.26,6.51S32,71,32,71",
    transform: "translate(-4.91 -9.33)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.48
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.68,89.15l19.15-51.1a4.37,4.37,0,0,1,4.09-2.83h80.64a4.37,4.37,0,0,1,4.36,4.37,4.48,4.48,0,0,1-.2,1.31l-18.53,58a4.35,4.35,0,0,1-4.52,3L44.39,95a4.37,4.37,0,0,1-4-4.71A4.54,4.54,0,0,1,40.68,89.15Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#3cbdea",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.56,35.79,128,93.82a4.38,4.38,0,0,1-4.53,3L99.13,94.76,42.24,89.9a4.35,4.35,0,0,1-4-4.7A4.72,4.72,0,0,1,38.52,84L43.07,72,51.3,50l6.38-17a4.37,4.37,0,0,1,4.09-2.83h80.64a4.36,4.36,0,0,1,4.36,4.36A4.24,4.24,0,0,1,146.56,35.79Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "61.76 76.95 67.71 60.62 92.47 60.62 86.01 77.4 61.76 76.95",
    fill: "#3cbdea",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.56,35.79,128,93.82a4.38,4.38,0,0,1-4.53,3L99.13,94.76l22.45-60.94.17-.47,24.94.26a2.07,2.07,0,0,0,0,.22A4.34,4.34,0,0,1,146.56,35.79Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#3cbdea"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.74,40.39,61.61,60.72a1.54,1.54,0,0,1-1.5,1.13l-16.28-.47,8.24-22,14.3-.84A1.39,1.39,0,0,1,67.74,40.39Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#3cbdea",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.43,55.72l6.34-17.95a1.55,1.55,0,0,1,1.35-1.05l26.72-1.58A1.41,1.41,0,0,1,66.22,37L60.09,57.34a1.56,1.56,0,0,1-1.5,1.14l-26.94-.81A1.41,1.41,0,0,1,30.43,55.72Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "141.82 24.28 141.82 24.51 141.82 24.76 116.67 24.5 52.77 23.85 52.77 23.37 116.84 24.02 141.78 24.28 141.82 24.28",
    fill: "#3cbdea"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "34.27 44.51 30.85 44.51 32.65 39.86 36.06 39.86 34.27 44.51",
    fill: "#3cbdea"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "38.48 44.51 35.06 44.51 38.72 35.05 42.14 35.05 38.48 44.51",
    fill: "#3cbdea"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "42.7 44.51 39.28 44.51 41.51 38.75 44.92 38.75 42.7 44.51",
    fill: "#3cbdea"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "46.91 44.51 43.49 44.51 48.31 32.05 51.73 32.05 46.91 44.51",
    fill: "#3cbdea"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "38.48 44.51 35.06 44.51 38.72 35.05 42.14 35.05 38.48 44.51",
    fill: "url(#linear-gradient)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "46.91 44.51 43.49 44.51 48.31 32.05 51.73 32.05 46.91 44.51",
    fill: "url(#linear-gradient-2)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "51.13 44.51 47.71 44.51 53.87 28.57 57.29 28.57 51.13 44.51",
    fill: "#3cbdea"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135,48.32a5.85,5.85,0,1,0-.12.39l.06-.19Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.21,85.45a5.88,5.88,0,0,0-11.27-3.24c0,.06,0,.13,0,.19s0,.13-.07.19a5.87,5.87,0,0,0,11,4c.06-.19.11-.38.17-.57S122.14,85.64,122.21,85.45Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.19,64.9a5.87,5.87,0,0,0-11.74,0v.41a5.87,5.87,0,0,0,11.74,0V64.9Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.16,46.71h0l1.38-4.43a4.87,4.87,0,0,0-1.2-.21,4.65,4.65,0,0,0-4.61,3.25,4.87,4.87,0,0,0-.21,1.2,5,5,0,0,0,.11,1.21,4.54,4.54,0,0,0,1.12,2.12,4.58,4.58,0,0,0,4.43,1.38,5.1,5.1,0,0,0,1.13-.41,4.92,4.92,0,0,0,1-.7,4.71,4.71,0,0,0,1.28-2Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#3cbdea"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.4,65.09h0V60.45a4.68,4.68,0,0,0-2.31.63,4.37,4.37,0,0,0-1,.74,4.62,4.62,0,0,0,2.09,7.75,4.45,4.45,0,0,0,2.4,0,4.69,4.69,0,0,0,1.12-.45Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#3cbdea"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.47,84.21l1.44-4.41a4.77,4.77,0,0,0-2.4-.13,4.64,4.64,0,0,0-3.67,4.3,4.4,4.4,0,0,0,.1,1.2,4.54,4.54,0,0,0,.4,1.14A4.6,4.6,0,0,0,115,88.62l1.44-4.42Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#3cbdea"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.61,66.53a.92.92,0,0,1-.31.48,1.48,1.48,0,0,1-.71.19,1.55,1.55,0,0,0-.74.25.42.42,0,0,0,0,.38l.29,1.62a.65.65,0,0,1,0,.39.56.56,0,0,1-.37.26c-.58.23-1.3.43-1.76,0a1.79,1.79,0,0,1-.43-.87,17.78,17.78,0,0,1-.9-5.63,4,4,0,0,1,1.32-3.08,3.9,3.9,0,0,1,2.85-.66,1.38,1.38,0,0,1,1.06.73c.13.29,0,.57,0,.88A8.75,8.75,0,0,0,58,62.83a6.25,6.25,0,0,0,.16.62,2.09,2.09,0,0,1,.16.54,2.22,2.22,0,0,1-.29,1,6.23,6.23,0,0,0-.37,1.13A2.1,2.1,0,0,1,57.61,66.53Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#fdb9a9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.91,78.53s2,2.14,3.68,2.14,9.09-7,9.09-7a3.27,3.27,0,0,0,1.7-1.92c.07-.29.05-.59.1-.88a3.9,3.9,0,0,1,.77-1.6.6.6,0,0,0,.17-.49c-.06-.22-.32-.29-.54-.33a2.93,2.93,0,0,0-2.09.17,2.65,2.65,0,0,0-.91,1.48,1.79,1.79,0,0,0-.8-.64.48.48,0,0,0-.21.58,5.76,5.76,0,0,0,.26.62,2,2,0,0,1-.84,2,8.93,8.93,0,0,1-1.23.8l-4.54,2.65c-.46.27-1,.55-1.5.3-.23-.12-.39-.35-.64-.46a1.14,1.14,0,0,0-1.08.34A6.8,6.8,0,0,0,58.91,78.53Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#fdb9a9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.82,108.15a4.2,4.2,0,0,1-1.85,3c-1.86.87-4.25,1.09-6.25,1.52-1.21.27-2.42.54-3.61.86-1,.27-2.07.24-2.75,1.12-.41.52-.68,1.26-1.32,1.41a1.19,1.19,0,0,1-1.19-.54,2.83,2.83,0,0,1-.4-1.33,1.58,1.58,0,0,1,0-.53,1.24,1.24,0,0,1,.28-.5,5.56,5.56,0,0,1,2.42-1.29,15.35,15.35,0,0,0,2.25-1,11.71,11.71,0,0,1,1.84-.72l3.65-1.33c.86-.31,2.15-.43,2.48-1.41a6,6,0,0,0,.19-1.47,6.26,6.26,0,0,1,.88-2.78.82.82,0,0,1,.29-.35,1,1,0,0,1,.49-.12,3,3,0,0,1,1.38.16,2.41,2.41,0,0,1,1.23,1.39,5,5,0,0,1,.22,1.88A11.84,11.84,0,0,1,40.82,108.15Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#fdb9a9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.39,112.77c-.06.26-.26.47-.33.73a1.72,1.72,0,0,0,0,.64l.19,1a.75.75,0,0,0,.86.71.28.28,0,0,1,.21.12.25.25,0,0,1,0,.17l-.28,1.27a6.17,6.17,0,0,1-.55,1.53.47.47,0,0,1-.24,0c-.64,0-.89-1.62-1.12-2.23a4.39,4.39,0,0,1-.15-1.91c0-.35.06-.69.11-1a2.88,2.88,0,0,1,.19-1,.46.46,0,0,1,.43-.25C23.91,112.56,24.46,112.48,24.39,112.77Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#3cbdea"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5,108.34a4.15,4.15,0,0,1,.56,3.52c-.85,1.86-2.53,3.59-3.76,5.21-.76,1-1.5,2-2.21,3-.58.85-1.41,1.52-1.36,2.63,0,.66.3,1.4-.09,1.93a1.2,1.2,0,0,1-1.26.36,2.81,2.81,0,0,1-1.16-.75,1.61,1.61,0,0,1-.33-.41,1.24,1.24,0,0,1-.11-.57,5.45,5.45,0,0,1,1-2.55,14.76,14.76,0,0,0,1-2.25,10.93,10.93,0,0,1,.94-1.75l1.91-3.38c.46-.79,1.37-1.72,1-2.68a5.88,5.88,0,0,0-.81-1.24,6.4,6.4,0,0,1-1.14-2.68,1.19,1.19,0,0,1,0-.46,1,1,0,0,1,.29-.41,3.06,3.06,0,0,1,1.17-.77,2.35,2.35,0,0,1,1.83.26,4.85,4.85,0,0,1,1.39,1.28A12.07,12.07,0,0,1,51.5,108.34Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#fdb9a9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42,122.51c.12.24.11.53.23.77a1.48,1.48,0,0,0,.44.46l.77.63a1.17,1.17,0,0,0,.3.19,1.08,1.08,0,0,0,.82-.2.19.19,0,0,1,.33.07l.61,1.16a5.86,5.86,0,0,1,.58,1.51.49.49,0,0,1-.16.19c-.5.41-1.73-.66-2.29-1A4.44,4.44,0,0,1,42.24,125c-.2-.28-.39-.57-.58-.85a3,3,0,0,1-.48-.85.49.49,0,0,1,.17-.49C41.48,122.66,41.85,122.25,42,122.51Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#3cbdea"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.42,76a.64.64,0,0,1-.23.33c-.76.73-1.53,1.44-2.28,2.17a6,6,0,0,1-.78.63c-.25.15-.52.25-.77.4a1.88,1.88,0,0,0-.24.18,4.68,4.68,0,0,0-1.2,1.76c-.19.41-.37.84-.52,1.27a19.54,19.54,0,0,0-.89,3.44c-1.15,6.68.35,13.49,1.13,20.19.1.74.17,1.48.23,2.22,0,.31.06.63.08.95a1.27,1.27,0,0,1-.13.83,1.24,1.24,0,0,1-.61.39c-3.38,1.37-7.19,2.45-10.62,1.23-2.22-.79-4-2.45-5.94-3.79s-4.36-2.38-6.63-1.72a6.91,6.91,0,0,1,1.71-4.44,12.1,12.1,0,0,1,1.21-1.37l.9-.89c3-2.93,5.57-5.46,7.18-9.57.65-1.67.78-3.63,1.88-5.09,1-1.25,1.77-1.38,2-3.06a37.54,37.54,0,0,1,1.43-6.19,15,15,0,0,1,2.79-5,7.34,7.34,0,0,1,1.92-1.72,3.69,3.69,0,0,1,2.49-.51,2.48,2.48,0,0,1,1.91,1.57c.77,2.27,2.77,3.26,3.86,5.41A.57.57,0,0,1,61.42,76Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#3cbdea"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.51,59.76a2.17,2.17,0,0,1-1.36,1.55c-1.55.61-3.69.36-3.26,2.57a7.54,7.54,0,0,1-.38,4.87,4.81,4.81,0,0,0-.88,1.91,4.63,4.63,0,0,0,.12.91,5,5,0,0,1-4,5.76,3.83,3.83,0,0,1-.58.07,3.64,3.64,0,0,0-1.71.29,3.1,3.1,0,0,0-1,1.57,3.47,3.47,0,0,1-1.13,1.64c-1.07.72-2.5.28-3.7-.21a9.5,9.5,0,0,1-2.53-1.36,3.49,3.49,0,0,1-1.36-2.45A5.94,5.94,0,0,0,36.71,75,8.9,8.9,0,0,0,36,74a3.59,3.59,0,0,1,.31-3.36,1.46,1.46,0,0,0,.21-.57,1.83,1.83,0,0,0-.14-.57,3.15,3.15,0,0,1,1.71-3.35,15.75,15.75,0,0,1,3.86-1.2,6.49,6.49,0,0,0,4.41-3.84c.77-1.64,1.42-3.43,3.18-4.25a8.92,8.92,0,0,1,8.21.95A1.8,1.8,0,0,1,58.51,59.76Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#473f47"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.13,79.16c-.25.15-.52.25-.77.4a1.37,1.37,0,0,0-.24.18,5.67,5.67,0,0,0-1.72,3,20.35,20.35,0,0,0-.9,3.45,38.93,38.93,0,0,0-.27,9.19,10.72,10.72,0,0,1-.1,3.35,10.59,10.59,0,0,1-2.43-5.52c-.14-1.11-.1-2.25-.33-3.35-.18-.79-.5-1.55-.63-2.35a.5.5,0,0,0,0-.12c-.21-1.44.35-1.65,1.16-2.48a7.84,7.84,0,0,0,1.72-3q1-3,2.09-5.91C55.56,76.53,57.51,78.17,58.13,79.16Z",
    transform: "translate(-4.91 -9.33)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.88,108.62a16.77,16.77,0,0,1-10.57-.27,10.36,10.36,0,0,1-3.49-2c-.39-.36-.74-.76-1.14-1.1a9,9,0,0,0-2-1.24c-1.55-.74-3.17-1.21-4.74-1.85l-.17-.07a13.17,13.17,0,0,1,1.21-1.37l.91-.89.2,0a11.13,11.13,0,0,1,2.91.81,28,28,0,0,1,4.19,2.94,27.39,27.39,0,0,0,4.14,2.29,12.36,12.36,0,0,0,2.87,1.05,12.88,12.88,0,0,0,3,.06,4.91,4.91,0,0,0,2.45-.59C55.74,107.14,55.81,107.87,55.88,108.62Z",
    transform: "translate(-4.91 -9.33)",
    fill: "#fff",
    opacity: 0.38,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.84 55.78 74.79 39.44 99.56 39.44 93.09 56.22 68.84 55.78",
    fill: "#3cbdea",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.98 8.56 112.23 13.3 110.5 19.34 101.98 8.56",
    fill: "#3cbdea"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.98 8.56 117.95 8.56 113.09 11.53 101.98 8.56",
    fill: "#3cbdea"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "114.94 15.97 112.23 13.3 101.98 8.56 113.09 11.53 114.94 15.97",
    fill: "#3cbdea"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "114.94 15.97 112.23 13.3 101.98 8.56 113.09 11.53 114.94 15.97",
    fill: "url(#linear-gradient-4)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "114.94 15.97 112.23 13.3 101.98 8.56 114.94 15.97",
    fill: "#3cbdea"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsp4);
export default __webpack_public_path__ + "static/media/USP4.b6ae98f8530007df7a41b88f503cf694.svg";
export { ForwardRef as ReactComponent };